import { LoanProvider } from "@logic/lib/constants"

export const LANGUAGES = [`en`, `es`]
export type Language = (typeof LANGUAGES)[number]

export type ExtendedWarranty = {
  name: string
  value: number
  equipmentId?: number
  warrantyId?: number
}

export const ROOF_TYPES = [
  `clay_tile`,
  `concrete_tile`,
  `flat_roof`,
  `metal`,
  `other`,
  `standard_asphalt`,
  `steel_shingle`,
] as const
export type RoofType = (typeof ROOF_TYPES)[number]

export const ADDER_UNITS = [`project`, `watt`, `array`, `unit`, `ft`] as const
export type AdderUnit = (typeof ADDER_UNITS)[number]

export const FUNDING_TYPES = [
  `cash`,
  LoanProvider.goodleap,
  LoanProvider.mosaic,
  LoanProvider.sunlight,
  LoanProvider.enfin,
  LoanProvider.sungage,
]
export type FundingType = (typeof FUNDING_TYPES)[number]

// is it Required an Manual or automatic? Also this is not used anywhere
export const AdderProposalStatuses = [`automatic`, `manual`] as const
export type AdderProposalStatus = (typeof AdderProposalStatuses)[number]

export const PowurOsStatuses = [
  null,
  `Active`,
  `Inactive`,
  `Change Order Only`,
] as const
export type PowurOsStatus = (typeof PowurOsStatuses)[number]

// Wire values PowurOS accepts as `proposalType` on pricing and
// proposal-warranty requests.
export enum PowurOsProposalType {
  Solar = 1,
  Battery = 2,
}

export enum PowurOsStatusEnum {
  Active = 1,
  Inactive = 2,
  "Change Order Only" = 3,
}

export enum PowurOsEquipmentAssociationTypeEnum {
  UNIT = 1,
  PANEL = 2,
}

export const INVERTER_POWUR_OS_EQUIPMENT_ID = 1
export const OPTIMIZER_POWUR_OS_EQUIPMENT_ID = 2
export const MODEM_POWUR_OS_EQUIPMENT_ID = 3
export const ENERGY_BACKUP_POWUR_OS_EQUIPMENT_ID = 4
export const AUTO_TRANSFORMER_POWUR_OS_EQUIPMENT_ID = 6
export const CABLES_POWUR_OS_EQUIPMENT_ID = 7
export const BATTERY_COMPONENTS_POWUR_OS_EQUIPMENT_ID = 12
export const MODULE_POWUR_OS_EQUIPMENT_ID = 13
export const SMART_PANEL_POWUR_OS_EQUIPMENT_ID = 14
export const EV_CHARGER_POWUR_OS_EQUIPMENT_ID = 16
export const COMPUTER_POWUR_OS_EQUIPMENT_ID = 18

export const SOLAREDGE_POWUR_OS_MANUFACTURER_ID = 38
export const TESLA_POWUR_OS_MANUFACTURER_ID = 48
export const ENPHASE_POWUR_OS_MANUFACTURER_ID = 12
/** The only AI compute (Computer) manufacturer contracts support (`deriveAiComputeManufacturer`). */
export const VENDOR_POWUR_OS_MANUFACTURER_ID = 62
export const FRANKLIN_POWUR_OS_MANUFACTURER_ID = 47
export const HANWHA_POWUR_OS_MANUFACTURER_ID = 14
export const UNKNOWN_POWUR_OS_MANUFACTURER_ID = -1
export const QCELL_POWUR_OS_MANUFACTURER_ID = 30

// Array of valid manufacturer IDs
// export const ALLOWED_GOODLEAP_TPO__MODULE_MANUFACTURE_IDS: string[] = [
//   `1`,
//   `52`,
//   `20`,
//   `23`,
//   `26`,
//   `14`,
//   `31`,
//   `37`,
// ]

// export const INVERTER_MANUFACTURER_POWUR_OS_IDS = [
//   SOLAREDGE_POWUR_OS_MANUFACTURER_ID,
//   ENPHASE_POWUR_OS_MANUFACTURER_ID,
//   TESLA_POWUR_OS_MANUFACTURER_ID,
// ]
// export type InverterManufacturerPowurOsId =
//   (typeof INVERTER_MANUFACTURER_POWUR_OS_IDS)[number]

export enum UNIT_OF_MEASURE {
  WATT = 0,
  UNIT = 1,
  FOOT = 2,
  SQFT = 3,
  PANEL = 4,
  PROJECT = 5,
  ARRAY = 6,
  SQ = 7,
}

export const PrettyUnit: Record<string, string> = {
  WATT: `watt`,
  UNIT: `unit`,
  FOOT: `ft`,
  SQFT: `sq ft`,
  PANEL: `panel`,
  PROJECT: `project`,
  ARRAY: `array`,
  SQ: `sq`,
}

export enum ADDER_PROPOSAL_TYPE {
  NONE = 0,
  MANUAL = 1,
  REQUIRED = 2,
}

export enum ADDER_PROPOSAL_USE_TYPE {
  MANUAL = 1,
  REQUIRED = 2,
  INTERNAL = 3,
  NOT_REQUIRED = 4,
}

export enum ADDER_CATEGORY {
  "EvAdders" = -3,
  "Warranties" = -2,
  "Rebates" = -1,
  "All Adders" = 0,
  "Electrical" = 1,
  "Mounting" = 2,
  "Miscellaneous" = 4,
  "Base Services" = 10,
  "Roof Type" = 11,
  "Ground Mounts" = 12,
  "Battery Installation" = 13,
  "Generators" = 14,
  "Travel" = 15,
  "Cancellation" = 16,
  "Electric Vehicle" = 17,
  "Lead Acquisition" = 22,
}

export const CONTRACTED_RATE_TYPE = [`default`, `override`] as const
export type ContractedRateType = (typeof CONTRACTED_RATE_TYPE)[number]
